import { render, staticRenderFns } from "./PriceIndicatorCell.vue?vue&type=template&id=4bd8df85"
import script from "./PriceIndicatorCell.vue?vue&type=script&lang=js"
export * from "./PriceIndicatorCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports